<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card">
      <div role="toolbar">
        <div class="flex align-items-center">
          <div>
            <i *ngIf="mode == 'create'" class="pi pi-plus-circle mr-1 title-card-icon"></i>
            <i *ngIf="mode == 'edit'" class="pi pi-pencil mr-1 title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">
              {{(mode == 'create' ? 'misc.creation.user' : 'misc.edition.user') | transloco | capitalize}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-4 xl:col-3">
    <p-timeline [value]="items" align="left" styleClass="timeline-hidden-opposite lg:pr-2">
      <ng-template pTemplate="marker" let-item>
        <span
          class="custom-marker p-shadow-1"
          [class]="(item.index != currentStep) ? (item.index < currentStep) ? 'step-completed' : 'step-inactive' : 'step-active'"
        >
          <i class="text-white" [ngClass]="(item.index >= currentStep) ? item.icon : 'pi pi-check'"></i>
        </span>
      </ng-template>
      <ng-template pTemplate="content" let-item>
        <div class="card mb-4">
          <h4 [class]="(item.index != currentStep) ? 'step-text-inactive' : 'step-text-active'">{{item.label}}</h4>
          <div *ngIf="item.description">{{item.description}}</div>
        </div>
      </ng-template>
    </p-timeline>
  </div>

  <div class="col-12 lg:col-8 xl:col-9" *ngIf="formLoaded">
    <div *ngIf="currentStep === 0">
      <app-users-form-info
        [(user)]="user"
        (nextStep)="nextStep()"
        [mode]="mode"
        [requiredUserActions]="requiredUserActions"
      ></app-users-form-info>
    </div>
    <div *ngIf="currentStep === 1">
      <app-users-form-credentials
        [(userCredentials)]="userCredentials"
        (previousStep)="previousStep()"
        (nextStep)="nextStep()"
        [mode]="mode"
      ></app-users-form-credentials>
    </div>
    <div *ngIf="currentStep === 2 && userApplications">
      <app-users-form-applications
        [(userApplications)]="userApplications"
        (userApplicationsChange)="this.userApplications = $event"
        (previousStep)="previousStep()"
        (nextStep)="nextStep()"
      ></app-users-form-applications>
    </div>

    <div *ngIf="currentStep === 3">
      <div class="card">
        <div class="flex flex-column p-3">

          <h2>{{'model.user' | transloco}} {{user.username}}</h2>

          <h4 class="mt-4 bold">{{'common.information' | transloco}}</h4>
          <div class="grid">
            <div class="col-12 lg:col-6 xl:col-4">
              <p class="bold p-0 m-0">{{'attribute.firstName' | transloco}}</p>
              <p [class.font-italic]="!user.firstName">{{user.firstName ? user.firstName : ('empty.firstName' | transloco)}}</p>
            </div>
            <div class="col-12 lg:col-6 xl:col-4">
              <p class="bold p-0 m-0">{{'attribute.lastName' | transloco}}</p>
              <p [class.font-italic]="!user.lastName">{{user.lastName ? user.lastName : ('empty.lastName' | transloco)}}</p>
            </div>
            <div class="col-12 lg:col-6 xl:col-4">
              <p class="bold p-0 m-0">{{'attribute.email' | transloco}}</p>
              <p [class.font-italic]="!user.email">{{user.email ? user.email : ('empty.email' | transloco)}}</p>
            </div>
            <div class="col-12 lg:col-6 xl:col-4">
              <p class="bold p-0 m-0">{{'attribute.emailVerified' | transloco}}</p>
              <p>{{(user.emailVerified ? 'common.yes' : 'common.no') | transloco}}</p>
            </div>
            <div class="col-12 lg:col-6 xl:col-4">
              <p class="bold p-0 m-0">{{'attribute.userenabled' | transloco}}</p>
              <p>{{(user.enabled ? 'common.yes' : 'common.no') | transloco}}</p>
            </div>
          </div>

          <h4 class="mt-4 bold">{{'attribute.requiredActions' | transloco}}</h4>
          <div class="w-full">
            <div *ngFor="let action of requiredUserActions">
              <div *ngIf="user.requieredActions?.includes(action.code)" class="flex align-items-center">
                <i class="text-primary" [className]="action.icon"></i>
                <p class="ml-3">{{action.name}}</p>
              </div>
            </div>
            <p *ngIf="!user.requieredActions || user.requieredActions.length === 0" class="font-italic">
              {{'empty.requiredActions' | transloco}}
            </p>
          </div>

          <h4 class="mt-6 bold">{{'model.credentials' | transloco}}</h4>
          <div class="grid">
            <div class="col-12 xl:col-6">
              <p class="bold p-0 m-0">{{'attribute.password' | transloco}}</p>
              <p>{{userCredentials.value}}</p>
            </div>
            <div class="col-12 xl:col-6">
              <p class="bold p-0 m-0">{{'attribute.passwordtemporary' | transloco}}</p>
              <p>{{(userCredentials.temporal ? 'common.yes' : 'common.no') | transloco}}</p>
            </div>
          </div>

          <h4 class="mt-6 bold">{{'model.applications' | transloco}}</h4>
          <div class="grid">
            <div class="col-12 xl:col-3 flex flex-column">
              <p class="bold p-0 m-0">{{'role.superAdmin' | transloco}}</p>
              <div class="apps-card p-2 mt-2 flex-1" *ngIf="userApplications.superadmin.length > 0">
                <div *ngFor="let app of userApplications.superadmin" class="p-2">
                  {{app}}
                </div>
              </div>
              <p *ngIf="userApplications.superadmin.length == 0" class="font-italic">
                {{'empty.applications' | transloco}}
              </p>
            </div>
            <div class="col-12 xl:col-3 flex flex-column">
              <p class="bold p-0 m-0">{{'role.admin' | transloco}}</p>
              <div class="apps-card p-2 mt-2 flex-1" *ngIf="userApplications.admin.length > 0">
                <div *ngFor="let app of userApplications.admin" class="p-2">
                  {{app}}
                </div>
              </div>
              <p *ngIf="userApplications.admin.length == 0" class="font-italic">
                {{'empty.applications' | transloco}}
              </p>
            </div>
            <div class="col-12 xl:col-3 flex flex-column">
              <p class="bold p-0 m-0">{{'role.operator' | transloco}}</p>
              <div class="apps-card p-2 mt-2 flex-1" *ngIf="userApplications.operator.length > 0">
                <div *ngFor="let app of userApplications.operator" class="p-2">
                  {{app}}
                </div>
              </div>
              <p *ngIf="userApplications.operator.length == 0" class="font-italic">
                {{'empty.applications' | transloco}}
              </p>
            </div>
            <div class="col-12 xl:col-3 flex flex-column">
              <p class="bold p-0 m-0">{{'role.viewer' | transloco}}</p>
              <div class="apps-card p-2 mt-2 flex-1" *ngIf="userApplications.viewer.length > 0">
                <div *ngFor="let app of userApplications.viewer" class="p-2">
                  {{app}}
                </div>
              </div>
              <p *ngIf="userApplications.viewer.length == 0" class="font-italic">
                {{'empty.applications' | transloco}}
              </p>
            </div>
          </div>

          <div class="flex justify-content-between mt-6">
            <div>
              <button
                pButton
                label="{{'common.cancel' | transloco}}"
                iconPos="right"
                class="p-button-danger"
                (click)="cancelAction()"></button>
            </div>
            <div>
              <button
                [label]="'common.previous' | transloco"
                [disabled]="persistingChanges"
                (click)="previousStep()"
                pButton
                iconPos="left"
                icon="pi pi-angle-left"
              ></button>
              <p-button
                [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
                [loading]="persistingChanges"
                (onClick)="persistUserData()"
                class="ml-2"
                styleClass="p-button-primary"
              ></p-button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
